import { createSlice } from "@reduxjs/toolkit";
import { PRICING_MODEL_TYPE } from "./AddClientConfig";


const defaultAmount = 0
const initialState = {
  _id: null,
  clientName: "",
  directedTo: "",
  clientType: "",
  clientIndustry: "",
  contactEmails: [],
  haveAQuoteEnabled: false,
  cipAccessControl: {
    accessRight: "CIP",
    onboardingState: "onboarding_with_forms"
  },
  salesPoc: null,
  pricingMatrix: {
    enabled: false,
    pricingModel: {
      type: PRICING_MODEL_TYPE.DEFAULT,
      B2B: defaultAmount,
      B2C: defaultAmount,
      HIGH_NET: defaultAmount,
      HEALTHCARE: defaultAmount,
      GOVT_OFFICIALS: defaultAmount
    }
  },
  onboarding: null,
  panelDashboardLink: "",
  collateralLinks: {
    link1: "",
    link2: "",
    link3: ""
  },
  country: "",
  region: "",
  cipVersion: "",
  haveAQuoteVersion: "",
  isEdit: false
};

export const sliceName = "CIPClient"

export const CIPClientSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    resetCipClientSlice: () => {
      return initialState
    },
    setPricingMatrixAccess: (state, action) => {
      state.pricingMatrix.enabled = action.payload
    },
    setPricingModelValues: (state, action) => {
      state.pricingMatrix.pricingModel[action.payload.key] = action.payload.value
    },
    setHaveAQuoteAccess: (state, action) => {
      state.haveAQuoteEnabled = action.payload
    },
    setCipAccessRight: (state, action) => {
      state.cipAccessControl.accessRight = action.payload
    },
    setCipOnboardingState: (state, action) => {
      state.cipAccessControl.onboardingState = action.payload
    },
    resetPricingMatrix: (state) => {
      state.pricingMatrix = initialState.pricingMatrix
    },
    resetPricingModel: (state) => {
      state.pricingMatrix.pricingModel = { ...initialState.pricingMatrix.pricingModel, type: state.pricingMatrix.pricingModel.type }
    },

    setCipClientSlice: (state, action) => {
      return action.payload
    },
    setCipClientIsEdit: (state, action) => {
      state.isEdit = action.payload
    }
  }
})


export const { resetCipClientSlice, setPricingMatrixAccess, setPricingModelValues, setHaveAQuoteAccess, resetPricingMatrix, resetPricingModel, setCipClientSlice, setCipAccessRight, setCipOnboardingState, setCipClientIsEdit } = CIPClientSlice.actions

export const selectHaveAQuoteEnabled = state => state[sliceName].haveAQuoteEnabled
export const selectPricingMatrixEnabled = state => state[sliceName].pricingMatrix.enabled
export const selectPricingMatrixModel = state => state[sliceName].pricingMatrix.pricingModel
export const selectCipClient = state => state[sliceName]
export const selectCipClientIsEdit = state => state[sliceName].isEdit


export default CIPClientSlice.reducer